/**
 * Represent the types of sources to handle in the Paste Plugin
 */
export enum CompatibleKnownPasteSourceType {

    WordDesktop,
    ExcelDesktop,
    ExcelOnline,
    PowerPointDesktop,
    GoogleSheets,
    WacComponents,
    Default,
    SingleImage,
}
